import { accountTabs } from 'containers/AccountSettings/constants';

import { PATHS } from 'constants/routerPaths';

export const getSubscriptionsPageUrl = () => `${PATHS.ACCOUNT_DEFAULT}/${accountTabs.Subscription}`;
